<style lang="sass" scoped>
input[readonly].datepicker-input {
  background-color: #fff;
}

div.datepicker > button.close {
  position: absolute;
  top: calc(50% - 13px);
  right: 10px;
}

div.datepicker > button.close {
  outline: none;
  z-index: 2;
}

div.datepicker > button.close:focus {
  opacity: .2;
}

.datepicker {
  position: relative;
}
.form-inline .datepicker {
  display: inline-block;
  width: auto;
  vertical-align: middle;
}

.datepicker-popup {
  position: absolute;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: #fff;
  margin-top: 2px;
  z-index: 1000;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
}

.datepicker-inner {
  font-size: 14px;
}

.datepicker-body {
  padding: 10px 10px;
}

.datepicker-ctrl p,
.datepicker-ctrl span,
.datepicker-body span {
  display: inline-block;
  width: 28px;
  line-height: 28px;
  height: 28px;
  border-radius: 4px;
}

.datepicker-ctrl p {
  width: 65%;
}

.datepicker-ctrl span {
  position: absolute;
}

.datepicker-body span {
  text-align: center;
}

.datepicker-monthRange span {
  width: 48px !important;
  height: 50px !important;
  line-height: 45px !important;
}

.datepicker-decadeRange span {
  width: 39px !important;
  height: 40px !important;
  line-height: 40px !important;
}

.datepicker-item-disable {
  background-color: white !important;
  cursor: not-allowed !important;
}

.datepicker-item-disable,
.datepicker-item-gray {
  color: #999;
}

.datepicker-item-active:hover,
.datepicker-item-active {
  background: rgb(50, 118, 177) !important;
  color: white !important;
}

.datepicker-monthRange,
.datepicker-decadeRange {
  margin-top: 10px
}

.datepicker-monthRange span,
.datepicker-decadeRange span,
.datepicker-ctrl span,
.datepicker-ctrl p,
.datepicker-dateRange span {
  cursor: pointer;
}

.datepicker-monthRange span:hover,
.datepicker-decadeRange span:hover,
.datepicker-ctrl p:hover,
.datepicker-ctrl i:hover,
.datepicker-dateRange span:hover,
.datepicker-dateRange-item-hover {
  background-color: #eeeeee;
}

.datepicker-weekRange span {
  font-weight: bold;
}

.datepicker-label {
  background-color: #f8f8f8;
  font-weight: 700;
  padding: 7px 0;
  text-align: center;
}

.datepicker-ctrl {
  position: relative;
  height: 30px;
  line-height: 30px;
  font-weight: bold;
  text-align: center;
}

.month-btn {
  font-weight: bold;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.datepicker-preBtn {
  left: 2px;
}

.datepicker-nextBtn {
  right: 2px;
}
</style>


<template>
<div id="datepicker-{{ _uid }}" class="datepicker">
  <input
      class="form-control datepicker-input"
      type="text"
      v-bind:style="{width: width + 'px'}"
      @click="inputClick"
      value="{{ valueDate.format(dateFormat) }}"
      readonly
      :disabled="disabled"
  />
  <div class="datepicker-popup" v-bind:style="popupStyle" v-show="displayDayView">
    <div class="datepicker-inner" v-bind:style="innerStyle">
      <div class="datepicker-body">
        <div class="datepicker-ctrl">
          <span class="month-btn datepicker-preBtn" @click="addMonths(-1)">&lt;</span>
          <span class="month-btn datepicker-nextBtn" @click="addMonths(1)">&gt;</span>
          <p @click="switchMonthView">{{ viewDate.format('YYYY-MM') }}</p>
        </div>
        <div class="datepicker-weekRange">
          <span v-for="w in weekdayNames">{{ w }}</span>
        </div>
        <div class="datepicker-dateRange">
          <span v-for="d in dateRange" v-bind:class="d.sclass" @click="daySelect(d.day, this)">{{ d.day }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="datepicker-popup" v-bind:style="popupStyle" v-show="displayMonthView">
    <div class="datepicker-inner" v-bind:style="innerStyle">
      <div class="datepicker-body">
        <div class="datepicker-ctrl">
          <span class="month-btn datepicker-preBtn" @click="addYears(-1)">&lt;</span>
          <span class="month-btn datepicker-nextBtn" @click="addYears(1)">&gt;</span>
          <p @click="switchDecadeView">{{ viewDate.format('YYYY') }}</p>
        </div>
        <div class="datepicker-monthRange">
          <template v-for="m in monthNames">
          <span v-bind:class="{'datepicker-item-active': isCurrentMonth($index)}"
                @click="monthSelect($index)"
          >{{ m }}</span>
          </template>
        </div>
      </div>
    </div>
  </div>
  <div class="datepicker-popup" v-bind:style="popupStyle" v-show="displayYearView">
    <div class="datepicker-inner" v-bind:style="innerStyle">
      <div class="datepicker-body">
        <div class="datepicker-ctrl">
          <span class="month-btn datepicker-preBtn" @click="addYears(-10)">&lt;</span>
          <span class="month-btn datepicker-nextBtn" @click="addYears(10)">&gt;</span>
          <p>{{ decadeRange[0].year }} - {{ decadeRange[decadeRange.length - 1].year }}</p>
        </div>
        <div class="datepicker-decadeRange">
          <template v-for="y in decadeRange">
          <span v-bind:class="{'datepicker-item-active': isCurrentYear(y.year)}"
                @click.stop="yearSelect(y.year)"
          >{{ y.year }}</span>
          </template>
        </div>
      </div>
    </div>
  </div>
</div>
</template>


<script>
import moment from 'moment'
import EventListener from 'util/EventListener'

export default {
  name: 'ui-datepicker',
  props: {
    value: {
      type: String,
      twoWay: true,
    },
    dateFormat: {
      default: 'YYYY-MM-DD'
    },
    internalDateFormat: {
      default: 'YYYY-MM-DD'
    },
    width: {
      type: Number,
      default: 100
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      viewDate: moment(this.value, this.internalDateFormat),
      displayDayView: false,
      displayMonthView: false,
      displayYearView: false,
      weekdayNames: moment.weekdaysMin(),
      monthNames: moment.monthsShort(),
      innerWidth: 218,
    }
  },
  computed: {
    valueDate() {
      return moment(this.value, this.internalDateFormat)
    },
    decadeRange() {
      let range = []
      const firstYear = this.viewDate.year() - (this.viewDate.year() % 10)
      for (let i = 0; i < 10; i++) {
        range.push({year: firstYear + i})
      }
      return range
    },
    dateRange() {
      let range = []

      const startDate = this.viewDate.clone().startOf('month').startOf('week')
      const endDate = this.viewDate.clone().endOf('month').endOf('week')

      for (let d = startDate.clone(); d.isSameOrBefore(endDate); d.add(1, 'day')) {
        let sclass = ''
        if (d.isSame(this.valueDate)) {
          sclass = 'datepicker-item-active'
        } else if (d.month() != this.viewDate.month()) {
          sclass = 'datepicker-item-gray'
        }
        range.push({day: d.date(), sclass: sclass})
      }

      return range
    },
    popupStyle() {
      return {
        left: this.width / 2 - this.innerWidth / 2 + 'px'
      }
    },
    innerStyle() {
      return {
        width: this.innerWidth + 'px'
      }
    },
  },
  methods: {
    open() {
      this.displayDayView = true
      this.displayMonthView = this.displayYearView = false
    },
    close() {
      this.displayDayView = this.displayMonthView = this.displayYearView = false
    },
    isOpen() {
      return this.displayDayView || this.displayMonthView || this.displayYearView
    },
    isCurrentDay(day, month = this.viewDate.month(), year = this.viewDate.year()) {
      return day == this.valueDate.date() && month == this.valueDate.month() && year == this.valueDate.year()
    },
    isCurrentMonth(month, year = this.viewDate.year()) {
      return month == this.valueDate.month() && year == this.valueDate.year()
    },
    isCurrentYear(year) {
      return year == this.valueDate.year()
    },
    inputClick() {
      this.viewDate = this.valueDate.clone()
      this.isOpen() ? this.close() : this.open()
    },
    addMonths(n) {
      this.viewDate = this.viewDate.add(n, 'months').clone()
    },
    addYears(n) {
      this.viewDate = this.viewDate.add(n, 'years').clone()
    },
    switchMonthView() {
      this.displayDayView = false
      this.displayMonthView = true
    },
    switchDecadeView() {
      this.displayMonthView = false
      this.displayYearView = true
    },
    daySelect(day, el) {
      if (el.$el.classList.contains('datepicker-item-disable')) {
        return false
      } else {
        this.viewDate = this.viewDate.date(day).clone()
        this.value = this.viewDate.format(this.internalDateFormat)
        this.displayDayView = false
      }
    },
    monthSelect(month) {
      this.displayMonthView = false
      this.displayDayView = true
      this.viewDate = this.viewDate.month(month).clone()
    },
    yearSelect(year) {
      this.displayYearView = false
      this.displayMonthView = true
      this.viewDate = this.viewDate.year(year).clone()
    },
  },
  ready() {
    this.$dispatch('child-created', this)
    this._closeEvent = EventListener.listen(window, 'click', e => {
      if (!this.$el.contains(e.target)) {
        this.close()
      }
    })
  },
  beforeDestroy() {
    if (this._closeEvent) {
      this._closeEvent.remove()
    }
  }
}
</script>



// WEBPACK FOOTER //
// datepicker.vue?566dbd72